import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD_lkJWANO3qfl8wdVs0TG2hifT5lqMGic",
  authDomain: "trading-bot-ec20d.firebaseapp.com",
  projectId: "trading-bot-ec20d",
  storageBucket: "trading-bot-ec20d.appspot.com",
  messagingSenderId: "60154507116",
  appId: "1:60154507116:web:fb090968b40bd3f9d00d49",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };
export const signInWithGooglePopup = () => signInWithPopup(auth, provider);